import { useState } from "react";
import { withNamespaces } from "react-i18next";
import { useHistory } from "react-router-dom";
import { Accordion } from "react-bootstrap";

import EmptyState from "./components/empty-state";
import RequirementCards from "./components/requirement-cards";
import { REQUIRED_APPROVALS_VIEW_MODES } from "./helpers";
import useApprovalRequirements from "./hooks/useApprovalRequirements";
import RequiredApprovalsIcon from "src/modules/data-protection/assets/images/required-approvals.svg";
import { INFORMATION_ACCORDIONS } from "../../helpers/accordionDeepLink";
import useInformationAccordionFocus from "../../hooks/useInformationAccordionFocus";

import "./style.scss";

const REQUIRED_APPROVALS_EVENT_KEY =
    INFORMATION_ACCORDIONS.REQUIRED_APPROVALS;

const RequiredApprovals = ({ t, softwareId }) => {
    const history = useHistory();
    const [activeAccordion, setActiveAccordion] = useState(null);

    useInformationAccordionFocus(
        REQUIRED_APPROVALS_EVENT_KEY,
        setActiveAccordion
    );
    const { viewMode, cards, isLoading } = useApprovalRequirements({
        softwareId,
        t,
    });

    if (!viewMode) {
        return null;
    }

    const handleAccordionClick = () => {
        setActiveAccordion((prev) =>
            prev === REQUIRED_APPROVALS_EVENT_KEY
                ? null
                : REQUIRED_APPROVALS_EVENT_KEY
        );
    };

    const handleStartAssessment = () => {
        history.push({ search: "?tab=assessments" });
    };

    return (
        <Accordion
            activeKey={activeAccordion}
            className="mt-4 required-approvals"
        >
            <Accordion.Item
                eventKey={REQUIRED_APPROVALS_EVENT_KEY}
                data-information-accordion={REQUIRED_APPROVALS_EVENT_KEY}
                className={
                    activeAccordion === REQUIRED_APPROVALS_EVENT_KEY
                        ? "active"
                        : ""
                }
            >
                <Accordion.Header onClick={handleAccordionClick}>
                    <img src={RequiredApprovalsIcon} alt="" />
                    <span>{t("Required Approvals")}</span>
                </Accordion.Header>
                <Accordion.Body>
                    {!isLoading && viewMode === REQUIRED_APPROVALS_VIEW_MODES.empty ? (
                        <EmptyState onStartAssessment={handleStartAssessment} />
                    ) : null}
                    {!isLoading && viewMode === REQUIRED_APPROVALS_VIEW_MODES.list ? (
                        <RequirementCards
                            cards={cards}
                            softwareId={softwareId}
                            onGoToAssessment={handleStartAssessment}
                        />
                    ) : null}
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    );
};

export default withNamespaces()(RequiredApprovals);
